var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09264 21.442L0 24.5346L10.8242 29.1736L15.4654 40L18.558 36.9074L17.0117 29.1736L24.2578 21.9275L32.1534 38.7774L35.082 35.8488L32.4793 13.7082L38.6646 7.52074C39.0824 7.11722 39.4156 6.63454 39.6449 6.10086C39.8741 5.56717 39.9948 4.99317 39.9998 4.41236C40.0049 3.83154 39.8942 3.25553 39.6743 2.71794C39.4543 2.18036 39.1295 1.69195 38.7188 1.28124C38.3081 0.870522 37.8197 0.545716 37.2821 0.325771C36.7445 0.105827 36.1685 -0.00485148 35.5877 0.000195677C35.0069 0.00524283 34.4329 0.125914 33.8992 0.355168C33.3655 0.584421 32.8828 0.917666 32.4793 1.33546L26.13 7.68478L3.98938 5.07987L1.22262 7.84881L17.9413 15.8757L10.8264 22.9905L3.09264 21.442Z",
    fill: "#9356F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.a7a011a4b006ca24d3496e6a29c45da7.svg";
export { ForwardRef as ReactComponent };